/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { System } from "../../../types/admin-usuarios/System";
import { useFormik } from "formik";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import { Button, Col, Row } from "react-bootstrap";
import InputForm from "../../../components/inputs/InputForm";
import { Loader, toaster } from "rsuite";
import peticionBack from "../../../libs/peticiones/peticionBack";

const defaultForm: System = {
  name: ""
};

export default function Form({
  setOpen,
  selected,
}: {
  setOpen: any;
  selected?: any;
}) {
  const [loading, setLoading] = useState<boolean>(false);

  const formSchema = Yup.object().shape({
    name: Yup.string().required("Ingrese el nombre"),
  });

  const {
    handleSubmit,
    handleReset,
    handleBlur,
    setFieldValue,
    setValues,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: defaultForm,
    validationSchema: formSchema,
    onSubmit: (values) =>
      swalAction(
        save,
        `${selected ? "Editar" : "Guardar"} sistema`,
        `¿Desea ${selected ? "editar" : "guardar"} este sistema?`,
        "question"
      ),
    onReset: () => {
      setOpen(false);
    },
  });

  function onChange({ target }: { target: any }) {
    setFieldValue(target.name, target.value);
  }

  useEffect(()=>{
    if(selected){
        setValues({
            name: selected.name
        }, true);
    }
}, []);

async function save(){
    const method = selected ? "PUT" : "POST";
    const rute = selected ? `/${selected._id}` : "";
    setLoading(true);
    const res = await peticionBack({...values}, "/sistemas" + rute, method, true, toaster);
    if(res){
      handleReset(null);
    }
    setLoading(false);
}
  return(
  <form onSubmit={handleSubmit} onReset={handleReset}>
    <Row>
      <Col xs={12} md={12}>
        <InputForm
          label="Nombre sistema"
          name="name"
          type="text"
          value={values.name}
          touched={touched.name}
          error={errors.name}
          onChangeMethod={onChange}
          onBlurMethod={handleBlur}
          required
        />
      </Col>
    </Row>
    <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2">
      <Button variant="danger" type="reset" className="mt-3">
        Cancelar
      </Button>
      <Button variant="success" type="submit" className="mt-2 mt-sm-3">
        Guardar
      </Button>
    </div>
    { loading && <Loader backdrop vertical style={{zIndex: 5}}/> }
  </form>)
}
